export const moduleSlug = "METRIC";

export const collectionStatusFields = {
    branch: "branch_name",
    defaultInterval: "default_interval",
    scrapedListings: "average_scraped_listings_per_branch",
    errorRate: "average_error_rate_per_branch",
    screenshotsErrorRate: "average_screenshot_error_rate_per_branch",
    statusCheckErrorRate: "average_status_check_error_rate_per_branch",
};
export const defaultSortField = "branch_name";
export const defaultSortDirection = "asc";
export const MAX_CHARTS_NUMBER_FOR_MULTIPLE_DISPLAYING = 20;

export default { moduleSlug };
